export const orderStatus: Record<
  | "NOT_PAY"
  | "PAY_PROCESS"
  | "NOT_TEACHING"
  | "SUCCESS"
  | "CANCEL"
  | "REFUND"
  | "REFUND_REJECT"
  | "PAY_ERROR"
  | "REFUND_APPLY"
  | "DELETE"
  | "REFUND_ERROR",
  number
> = {
  // 1=待付款 2=金流處理中 3=已付款待授課 4=退款申請中 5=已授課已評論
  // 6=已取消 7=已退款 8=退款駁回 9=支付異常 10=退款異常 11=刪除
  NOT_PAY: 1,
  PAY_PROCESS: 2,
  NOT_TEACHING: 3,
  REFUND_APPLY: 4,
  SUCCESS: 5,
  CANCEL: 6,
  REFUND: 7,
  REFUND_REJECT: 8,
  PAY_ERROR: 9,
  REFUND_ERROR: 10,
  DELETE: 11,
};
